<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings"></ion-back-button>
    </ion-buttons>
    <ion-title>
      Salon Profile
    </ion-title>
    <ion-buttons slot="end">
      <ion-button 
        class="hidden-sm-down"
        fill="solid"
        color="primary"
        (click)="onSalonProfileSave()"
        >
        Save
      </ion-button>      
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>
  <salonmonster-tap-retry 
    *ngIf="errorOccurredWhileLoadingCountries" 
    (click)="loadCountries()">  
  </salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingCountries">

        <ng-container *ngIf="!isAdmin">
          <ion-item color="primary">
            Only administrators can edit this page.
          </ion-item>

          <ion-card>
            <ion-card-header>
              {{ salon.getName() }}
            </ion-card-header>
            <ion-card-content>
              {{ salon.getPhone() }}
              <br/>
              {{ salon.getEmail() }}
              <br/>
              {{ salon.getAddress1() }}
              <br/>
              {{ salon.getCity() }}
              <br/>
              {{ salon.getProvince() }}
              <br/>
              {{ salon.getPostal() }}
              <br/>
              {{ salon.getWebsite() }}
            </ion-card-content>
          </ion-card>
        </ng-container>

        <form [formGroup]='salonProfileForm' *ngIf="isAdmin">
          <ion-item class="ion-text-wrap ion-margin-left">
            <ion-label class="ion-text-wrap ion-margin-left">
              <h1>Enter and manage all your salon's contact details.</h1>
              Clients can view this information on your booking page and it will be included in emails you send to your clients.
            </ion-label>
          </ion-item>          
          <ion-grid>
            <ion-row>
              <ion-col size="12" size-xs="12" size-sm="12" size-md="6" size-lg="6" size-xl="6">
                <ion-item lines="none">
                  <ion-label position="stacked">Salon Name *</ion-label>
                  <ion-input type="text" name='' formControlName="salonName" autofocus=true clearInput></ion-input>
                </ion-item>

                <ion-item lines="none" [hidden]="salonName.valid || (salonName.pristine && !submitted)">
                  <p *ngIf="salonName.hasError('required')" class='smr-error'>
                    Salon Name is required.
                  </p>

                  <p *ngIf="salonName.hasError('maxlength')" class='smr-error'>
                    Salon Name cannot exceed 100 characters.
                  </p>
                </ion-item>

                <ion-item lines="none">
                  <ion-label position="stacked">Website</ion-label>
                  <ion-input type="text" name='' formControlName="website" clearInput></ion-input>
                </ion-item>

                <ion-item lines="none" [hidden]="website.valid || (website.pristine && !submitted)">
                  <p *ngIf="website.hasError('maxlength')">
                    Website address cannot exceed 100 characters.
                  </p>
                </ion-item>          

                <ion-item lines="none">
                  <ion-label position="stacked">Phone *</ion-label>
                  <ion-input type="tel" name='' formControlName="phone" clearInput></ion-input>
                </ion-item>

                <ion-item lines="none" [hidden]="phone.valid || (phone.pristine && !submitted)">
                  <p *ngIf="phone.hasError('validatePhone')" class='smr-error'>
                    Oops, this phone number is an invalid format.
                  </p>
                  <p *ngIf="phone.hasError('maxlength')" class='smr-error'>
                    Phone number cannot exceed 20 characters.
                  </p>
                </ion-item>

                <ion-item lines="none">
                  <ion-label position="stacked">Fax</ion-label>
                  <ion-input type="text" name='' formControlName="fax" clearInput></ion-input>
                </ion-item>

                <ion-item lines="none" [hidden]="fax.valid || (fax.pristine && !submitted)">
                  <p *ngIf="fax.hasError('maxlength')" class='smr-error'>
                    Fax number cannot exceed 20 characters.
                  </p>
                </ion-item>

                <ion-item lines="none">
                  <ion-label position="stacked">Email *</ion-label>
                  <ion-input type="email" name='' formControlName="email" clearInput></ion-input>
                </ion-item>

                <ion-item lines="none" [hidden]="email.valid || (email.pristine && !submitted)">
                  <p *ngIf="email.hasError('validateEmail')" class='smr-error'>
                    Oops, this email is invalid.
                  </p>
                  <p *ngIf="email.hasError('maxlength')" class='smr-error'>
                    Email cannot exceed 100 characters.
                  </p>
                </ion-item>
              </ion-col>
             
              <ion-col size="12" size-xs="12" size-sm="12" size-md="6" size-lg="6" size-xl="6" >
                <ion-item lines="none">
                  <ion-label position="stacked">Address *</ion-label>
                  <ion-input type="text" name='' formControlName="address1" clearInput></ion-input>
                </ion-item>

                <ion-item lines="none" [hidden]="address1.valid || (address1.pristine && !submitted)">
                  <p *ngIf="address1.hasError('maxlength')" class='smr-error'>
                    Address cannot exceed 40 characters.
                  </p>
                </ion-item>

                <ion-item lines="none">
                  <ion-label position="stacked">Address 2</ion-label>
                  <ion-input type="text" name='' formControlName="address2" clearInput></ion-input>
                </ion-item>

                <ion-item lines="none" [hidden]="address2.valid || (address2.pristine && !submitted)">
                  <p *ngIf="address2.hasError('maxlength')" class='smr-error'>
                    Address cannot exceed 40 characters.
                  </p>
                </ion-item>

                <ion-item lines="none">
                  <ion-label position="stacked">City *</ion-label>
                  <ion-input type="text" name='' formControlName="city" clearInput></ion-input>
                </ion-item>

                <ion-item lines="none" [hidden]="city.valid || (city.pristine && !submitted)">
                  <p *ngIf="city.hasError('maxlength')">
                    City cannot exceed 20 characters.
                  </p>
                </ion-item>

                <ion-item lines="none">
                  <ion-label position="stacked">Province/State *</ion-label>
                  <ion-input type="text" name='' formControlName="province" clearInput></ion-input>
                </ion-item>

                <ion-item lines="none" [hidden]="province.valid || (province.pristine && !submitted)">
                  <p *ngIf="city.hasError('maxlength')">
                    Province/State cannot exceed 25 characters.
                  </p>
                </ion-item>

                <ion-item lines="none">
                  <ion-label position="stacked">ZIP/Postal *</ion-label>
                  <ion-input type="text" name='' formControlName="postal" clearInput></ion-input>
                </ion-item>

                <ion-item lines="none" [hidden]="postal.valid || (postal.pristine && !submitted)">
                  <p *ngIf="postal.hasError('maxlength')">
                    ZIP/Postal code cannot exceed 7 characters.
                  </p>
                </ion-item>

                <ion-item lines="none" class="ion-padding-top">
                  <ion-label position="stacked">Country *</ion-label>
                  <ion-select placeholder="Select a Country" interface="popover" formControlName="country" mode="ios">
                    <ion-select-option *ngFor="let country of countries" [value]="country.getID()">
                      {{country.getCountryName()}}
                    </ion-select-option>
                  </ion-select>
                </ion-item>
                <br />
                <br />
                <br />
                <br />
                <br />

              </ion-col>
            </ion-row>
          </ion-grid>

        </form>
        <ion-item lines="none" class="ion-padding ion-margin">
          <ion-note class="ion-text-wrap">
            * To enable salonMonster's bulk email tools you must enter your salon name, phone, address, city, zip/postal and country. This is required for compliance with North American anti-SPAM laws. 
          </ion-note>     
        </ion-item>
  </ng-container>
</ion-content>

<ion-footer class="hidden-md-up ion-no-margin" *ngIf="!isLoading && !errorOccurredWhileLoadingCountries">
  <ion-toolbar class="ion-no-margin ion-no-padding">
      <ion-button 
        [disabled]="isLoading"  
        
        fill="solid"
        color="primary"
        expand="block"
        class="ion-no-margin"
        (click)="onSalonProfileSave()">
        Save
      </ion-button>
  </ion-toolbar>
</ion-footer>